import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import { compose } from 'recompose'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'

import allDataQuery from '../queries/allData'
import fetchNestedAssetUrls from '../utils/fetchNestedAssetUrls'
import withConnectionStatus from "../hocs/withConnectionStatus";

const styles = theme => ({
  disabledStyle: {
    opacity: 0.5
  },
  progressStyle: {
    position: 'relative',
    width: '100%'
  },
  errorStyle: {
    color: 'red'
  }
})

class OfflineAvailableButton extends Component {
  state = {
    fetching: false,
    error: false
  }

  fetchAssets = async () => {
    const { client, onFinish, stage } = this.props
    const { fetching } = this.state

    if (fetching) {
      return
    }

    this.setState({ fetching: true })

    try {
      const resGer = await client.query({
        query: allDataQuery,
        variables: { lang: 'de', stage }
      })
      console.log('DE fetching done')

      const resEng = await client.query({
        query: allDataQuery,
        variables: { lang: 'en', stage }
      })
      console.log('EN fetching done')

      await fetchNestedAssetUrls([
        ...resGer.data.vehicles,
        ...resGer.data.topicClusters,
        ...resGer.data.entryScreenItems,
        ...resEng.data.vehicles,
        ...resEng.data.topicClusters,
        ...resEng.data.entryScreenItems,
        ...resEng.data.podcasts
      ])
      console.log('Asset fetching done')

      this.setState({ fetching: false, error: false })

      if (onFinish) {
        onFinish()
      }
    } catch (error) {
      console.log('fetch error', JSON.stringify(error, null, 2))
      this.setState({ fetching: false, error: true })
    }
  }

  render() {
    const {
      classes: { disabledStyle, progressStyle, errorStyle },
      label
    } = this.props

    const { fetching, error } = this.state

    return (
      <div
        className={classNames(fetching && disabledStyle, error && errorStyle)}
        onClick={this.fetchAssets}
      >
        {label}
        {fetching && <LinearProgress className={progressStyle} />}
      </div>
    )
  }
}

export default compose(
  withStyles(styles),
  withApollo,
  withConnectionStatus
)(OfflineAvailableButton)



// WEBPACK FOOTER //
// ./src/components/OfflineAvailableButton.js